import { resolveImageUrl } from "@/storyblok/resolvers";
import { ClientsBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";

export default function Clients({ data }: { data: ClientsBlockData }) {
  return (
    <section
      className="section--client-logos"
      {...makeEditable(data)}
      style={{ "--color-background": data.background_color?.color }}
    >
      <div className="container container-size-xl">
        <div className="col">
          <h2>{data.title}</h2>
        </div>
        <div className="col client-logo-container">
          {data.clients.map((client) => {
            return (
              <div
                key={client._uid}
                className="logo-wrapper"
                {...makeEditable(client)}
              >
                <img
                  src={resolveImageUrl(client.logo, { height: 60 })}
                  alt={client.logo.alt}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
